import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const SponsorshipFormPage: React.FC = () => {
  const navigate = useNavigate();

  // Update these schema names as per your backend/config
  const schemaLogBenefits = "MM_Log_Benifits";
  const schemaNewSponsorPackage = "Sponsor";
  const schemaCreateNewSponsor = "MM Create New Sponsor";

  const { id } = useParams<{ id: string }>();

  const formLogBenefits = useMemo(() => createForm({}), []);
  const formNewSponsorPackage = useMemo(() => createForm({}), []);
  const formCreateNewSponsor = useMemo(() => createForm({}), []);

  const formLogBenefitsRef = useRef<{ handleSave: () => Promise<void> }>(null);
  const formNewSponsorPackageRef = useRef<{ handleSave: () => Promise<void> }>(
    null
  );
  const formCreateNewSponsorRef = useRef<{ handleSave: () => Promise<void> }>(
    null
  );

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={"Sponsorship Management"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.MEMBER_LIST)}
      />

      <Tabs
        items={[
          {
            key: "1",
            label: " Log Benifits",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formLogBenefits}
                  schemaName={schemaLogBenefits}
                  recordId={id}
                  ref={formLogBenefitsRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formLogBenefitsRef.current?.handleSave();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
          {
            key: "2",
            label: "New Sponsor Package",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formNewSponsorPackage}
                  schemaName={schemaNewSponsorPackage}
                  recordId={id}
                  ref={formNewSponsorPackageRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formNewSponsorPackageRef.current?.handleSave();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
          {
            key: "3",
            label: " Create New Sponsor",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formCreateNewSponsor}
                  schemaName={schemaCreateNewSponsor}
                  recordId={id}
                  ref={formCreateNewSponsorRef}
                />
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={() => {
                      formCreateNewSponsorRef.current?.handleSave();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default SponsorshipFormPage;
